<template>
  <button :class="setClassName" v-on:click="onClick">
    <span class="material-icons">{{iconName}}</span>{{buttonText}}
  </button>
</template>

<script>
export default {
  props: {
    buttonText: String,
    iconName: String,
    onClick: Function,
    buttonClass: String
  },
  computed: {
    setClassName: function() {
      return this.buttonClass + " btn-icon";
    }
  }
};
</script>

<style lang="scss" scoped>
span {
  vertical-align: middle;
  font-size: 18px;
  padding-bottom: 1px;
}

.btn-icon {
  padding: 0;
  border: none;
  color: #bd1f23;
  background-color: inherit;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
}

.btn-contact {
  font-size: 16px;
}

.btn-contact span {
  font-weight: 900;
}
</style>


